// extracted by mini-css-extract-plugin
export default {"alert__body":"Alert_alert__body__MSZcw"};